<!-- App.svelte -->
<script>
	import { Router, Link, Route } from "svelte-routing";
	import { link } from "svelte-routing";
	import Login from "./routes/login.svelte";
	import Home from "./routes/home.svelte";
	import Register from "./routes/register.svelte";
	import User from "./routes/user.svelte";
  import Panier from "./routes/panier.svelte";
  import Clients from "./routes/clients.svelte";
  import Jouets from "./routes/jouets.svelte";
  import Rdv from "./routes/rdv.svelte";


	var firebaseConfig = {
    apiKey: "AIzaSyDjaVYCad55eUZ6W78zWaxXKaXZdvTfSrI",
    authDomain: "baj-leperreux.firebaseapp.com",
    projectId: "baj-leperreux",
    storageBucket: "baj-leperreux.appspot.com",
    messagingSenderId: "225431793596",
    appId: "1:225431793596:web:0e75afa8da3d0bf9f405b9",
    measurementId: "G-RLJFH3CWQB"
  };
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  var auth = firebase.auth();
  var db = firebase.firestore();
  
	export let url = "";
  </script>
  
  <Router url="{url}">
	<div>
		<Route path="/" component="{Home}"  {auth} {db} />
		<Route path="login" component="{Login}" {auth} {db}/>
		<Route path="register" component="{Register}"  {auth} {db}/>
		<Route path="user" component="{User}"  {auth} {db}/>
    <Route path="panier" component="{Panier}" {auth} {db}/>
    <Route path="clients" component="{Clients}" {auth} {db}/>
    <Route path="jouets" component="{Jouets}" {auth} {db}/>
    <Route path="rdv" component="{Rdv}" {auth} {db}/>
	</div>
  </Router>
